<template>
  <div>
    <table>
      <tr>
        <th>ID</th>
        <th>AN</th>
        <th>ALID:</th>
        <th>PACKINGS:</th>
        <th>HISTORY:</th>
      </tr>
      <tr v-for="artwork in $store.state.artworks" :key="artwork.id">
        <td>{{ artwork.id }}</td>
        <td>{{ artwork.accession_number }}</td>
        <td>{{ artwork.artwork_location_id }}</td>
        <td>
          <table v-if="getArtworkPackings(artwork.id).length > 0">
            <tr v-for="packing in getArtworkPackings(artwork.id)" :key="packing.id">
              <td>{{ packing.colli }}</td>
              <td>{{ packing.location_id }}</td>
              <td>{{ packing.artwork_location_id }}</td>
            </tr>
          </table>
        </td>
        <td>
          <table>
            <tr v-for="log in getArtworkLocationHistory(artwork.id)" :key="log.id">
              <td>{{ log.created }}</td>
              <td>{{ log.storage }}</td>
              <td>{{ log.artwork_location_id }}</td>
              <td>{{ log.change_date }}</td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  methods: {
    getArtworkPackings(id) {
      return this.$store.state.packings.filter(packing => packing.artwork_id === id)
    },
    getArtworkLocationHistory(id) {
      return this.$store.state.artwork_location_logs.filter(log => log.artwork_id === id)
    },
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/artworks/LocationOverview.vue